import { Text } from '@procurify/ui'
import styled from 'styled-components'

export const GlobalSearchSuggestedPromptsHeadingStyled = styled(Text)`
  padding: ${(props) => props.theme.space.small}
    ${(props) => props.theme.space.medium};
`

export const GlobalSearchSuggestedPromptListStyled = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
`

export const GlobalSearchSuggestedPromptStyled = styled.button`
  display: flex;
  align-items: center;
  gap: ${(props) => props.theme.space.small};
  width: 100%;
  padding: ${(props) => props.theme.typography.pxToRem(8)}
    ${(props) => props.theme.space.medium};
  border: none;
  border-radius: ${(props) => props.theme.shape.borderRadius}px;
  background: transparent;
  cursor: pointer;
  text-align: left;
  font-family: inherit;

  &:hover {
    background: ${(props) => props.theme.colors.neutral};
  }

  &:focus-visible {
    outline: ${(props) => props.theme.typography.pxToRem(2)} solid
      ${(props) => props.theme.colors.primary};
    outline-offset: ${(props) => props.theme.typography.pxToRem(-2)};
  }
`
